import { render, staticRenderFns } from "./Arrests.vue?vue&type=template&id=7ca01fc0&scoped=true&"
import script from "./Arrests.vue?vue&type=script&lang=js&"
export * from "./Arrests.vue?vue&type=script&lang=js&"
import style0 from "./Arrests.vue?vue&type=style&index=0&id=7ca01fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca01fc0",
  null
  
)

export default component.exports